export default [{
        header: 'Setting',
        resource: 'user',
        action: 'read'
    },
    {
        title: 'Users',
        icon: 'UserIcon',
        children: [
            {
                title: 'Accounts',
                route: 'users',
                resource: 'user',
                action: 'read'
            },
            {
                title: 'Roles',
                route: 'roles',
                resource: 'rol',
                action: 'read'
            }
        ]
    },
    // {
    //     title: 'Groups',
    //     route: 'groups',
    //     icon: 'HomeIcon',
    //     resource: 'group',
    //     action: 'read'
    // },
    // {
    //     title: 'Roles',
    //     route: 'roles',
    //     icon: 'ShieldIcon',
    //     resource: 'rol',
    //     action: 'read'
    // },
    {
        title: 'Settings',
        route: 'settings',
        icon: 'SettingsIcon',
        resource: 'settings',
        action: 'read'
    }
]



